import angular from 'angular';
import { IModuleFederationService } from './moduleFederation.service';

export interface IConditionalModuleLoadService {
    getTargetService(moduleName, exposedModule, ecvModule, targetService): any | null;
    getSignatureService(): any | null;
    getCoverSheetService(): any | null;
    getSearchService(): any | null;
    getAddTeamMemberService(): any | null;
    getCreateTeamService(): any | null;
}
export class ConditionalModuleLoadService implements IConditionalModuleLoadService {
    static $inject = ['$injector', '$q', 'ModuleFederationService'];
    private serviceMap = {};
    private promiseMap = {};
    constructor(private $injector: angular.auto.IInjectorService, private $q: ng.IQService, private ModuleFederationService: IModuleFederationService) {
    }
    getTargetService(moduleName, exposedModule, ecvModule, targetService) {
        if (!this.serviceMap) this.serviceMap = {};
        if (!this.promiseMap) this.promiseMap = {};

        // Check if the service has already been instantiated and cached
        if (this.serviceMap[ecvModule]) {
            return this.$q.resolve(this.serviceMap[ecvModule]);
        }

        // Check if the injector already knows about the target service.
        if (this.$injector.has(targetService)) {
            const service = this.$injector.get(targetService);
            this.serviceMap[ecvModule] = service;
            return this.$q.resolve(service);
        }

        // If not, proceed with loading and/or injecting the module
        if (!this.promiseMap[ecvModule]) {
            this.promiseMap[ecvModule] = this.ModuleFederationService.loadRemoteModule(moduleName, exposedModule, ecvModule)
                .then(() => {
                    const service = this.$injector.get(targetService);
                    this.serviceMap[ecvModule] = service;
                    return service;
                });
        }

        return this.promiseMap[ecvModule];
    }
    getSignatureService(): any | null {
        return this.getTargetService('documentSignature', 'documentSignature/documentSignatureModule', 'eCareVault.documentSignature', 'documentSignatureService');
    }
    getCoverSheetService(): any | null {
        return this.getTargetService('coversheet', 'coversheet/coverSheetModule', 'eCareVault.coverSheetUploads', 'CoverSheetService');
    }
    getSearchService(): any | null {
        return this.getTargetService('search', 'search/searchModule', 'eCareVault.search', 'SearchService');
    }
    getAddTeamMemberService(): any | null {
        return this.getTargetService('teams','teams/teamsModule','eCareVault.addTeamMember', 'AddTeamMemberService');
    }
    getCreateTeamService(): any | null {
        return this.getTargetService('teams','teams/teamsModule','eCareVault.createTeam', 'CreateTeamService');
    }
}
angular.module('eCareVault')
    .service('ConditionalModuleLoadService', ConditionalModuleLoadService);
